import quotes from '@nextories/vue-tasks/src/i18n/langs/fr/quotes';

export default {
  ...quotes,
  clientPrice: '<span class="price-label">Prix client :</span><span class="u-font-size-default price-ttc">{priceTtc}</span><span class="price-ht">{priceHt}</span>',
  moverPrice: '<span class="price-label">Prix prestataire :</span><span class="price-ttc u-font-size-default">{priceTtc}</span><span class="price-ht">{priceHt}</span>',
  moverapp: '<span class="price-label">Prix moverapp :</span><span class="price-ttc u-font-size-default">{priceTtc}</span><span class="price-ht">{priceHt}</span>',
};
